import { useState, type FormEvent } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PhoneInput } from "@/components/PhoneInput";
import { Logo } from "@/components/Logo";
import { useEmployeeSession } from "@/store/EmployeeSessionContext";
import { normalizePhone } from "@/lib/employeeAuth";

const ERROR_COPY: Record<string, string> = {
  "not-found": "Số điện thoại không có trong hệ thống. Liên hệ quản lý để được thêm.",
  inactive: "Tài khoản đã bị vô hiệu hoá. Liên hệ quản lý.",
  "invalid-input": "Vui lòng nhập đầy đủ số điện thoại.",
};

export function EmployeeLogin() {
  const { login } = useEmployeeSession();
  const navigate = useNavigate();
  const location = useLocation();
  const [phone, setPhone] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e?: FormEvent) => {
    e?.preventDefault();
    if (loading) return;
    setError(null);
    if (normalizePhone(phone).length < 10) {
      setError("Vui lòng nhập đầy đủ số điện thoại.");
      return;
    }
    setLoading(true);
    const result = await login(phone);
    setLoading(false);
    if (result.ok) {
      // Respect redirect if coming from a protected route
      const redirectTo = (location.state as { from?: string })?.from || "/shifts";
      navigate(redirectTo, { replace: true });
    } else {
      setError(ERROR_COPY[result.reason] ?? "Đăng nhập thất bại. Thử lại.");
    }
  };

  return (
    <main className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-body px-4">
      {/* Decorative blobs — match kvc.thohouse.com vibe */}
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-pink-200 opacity-20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-blue-200 opacity-20 blur-3xl" />

      <div className="relative z-10 flex w-full max-w-sm flex-col items-center">
        <Logo size={96} className="drop-shadow-2xl" />
        <h1 className="mt-4 text-3xl font-black text-gray-900">Khu Vui Chơi Nhà Thỏ</h1>
        <p className="mt-1 text-sm tracking-wide text-gray-500">Đăng ký ca làm việc</p>

        <form
          onSubmit={submit}
          className="mt-8 w-full rounded-3xl bg-white p-8 shadow-xl ring-1 ring-pink-100"
        >
          <PhoneInput
            value={phone}
            onChange={setPhone}
            onSubmit={() => submit()}
            disabled={loading}
            error={error}
            autoFocus
          />
          <button
            type="submit"
            disabled={loading}
            className="btn-cta mt-6 w-full drop-shadow-pink-glow"
          >
            {loading ? "Đang kiểm tra…" : "Đăng nhập"}
          </button>
        </form>
      </div>
    </main>
  );
}
